import PropTypes from 'prop-types';
import React from 'react';

function CurrencyInput({
  value,
  onChange,
  currency = '£',
  id,
  placeholder,
  disabled = false
}) {
  const formatCurrency = val => {
    if (!val) return '';
    const number = parseFloat(val.toString().replace(/[^0-9.]/g, ''));
    if (isNaN(number)) return '';
    return `${currency}${number.toLocaleString('en-UK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const handleInputChange = e => {
    const rawInput = e.target.value;

    // Remove currency symbol and commas for parsing
    const cleaned = rawInput.replace(currency, '').replace(/,/g, '').trim();

    // Allow fully empty field
    if (cleaned === '') {
      onChange('');
      return;
    }

    // Accept valid numeric input
    if (/^[0-9]*\.?[0-9]*$/.test(cleaned)) {
      onChange(cleaned);
    }
  };

  return (
    <input
      type="text"
      id={id}
      name={id}
      className="form-control"
      placeholder={placeholder}
      value={formatCurrency(value)}
      onChange={handleInputChange}
      disabled={disabled}
    />
  );
}

CurrencyInput.propTypes = {
  currency: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.any,
  value: PropTypes.any
};

export default CurrencyInput;
